/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */

import Vue from 'vue';
import { moneyFixed } from '@/tools/money';
import moneyList from '../../moneyList.vue';
import invoiceDetail from '../../detail.vue';
import rowLink from '@/components/Base/baseRowlink.js';
import projectPriceTable from '@/components/invoice/projectPriceTable';
import detailOfCommission from '../../detail-of-commission';
import detailOfPark from '../../detail.park.vue';
import createExtend from '@C/createExtend';
import { bankRowLabelFiled } from '@/common/fields/bank';

// 莲须粉配 存醋官吏方式
const defineReactive = Vue.util.defineReactive;
// 订单类型
const ORDER_TYPE = new Map([
  [1, '支付订单'],
  [2, '综合服务费'],
  [3, '支付订单']
]);
export const BUSINESS_TYPE = new Map([
  [1, '汇总申报'],
  [2, '委托代开'],
  [3, '园区个体']
]);
export const STATUS_INVOICE = new Map([
  [0, '待开票'],
  [1, '待审核'],
  [2, '已开票'],
  [3, '已驳回'],
  [4, '部分开票']
]);

export const OFFLINE_STATUS_INVOICE = new Map([
  [0, '未提交'],
  [1, '待开票'],
  [2, '待确认'],
  [3, '已驳回'],
  [4, '已开票']
]);

export default {
  index: {
    width: '60px',
    label: '序号',
    type: 'index'
  },
  invoiceBusinessType: {
    label: '业务类型',
    prop: 'invoiceBusinessType',
    // formatter: (h, v) => BUSINESS_TYPE.get(+v)
    formatter: (h, ctx, v) => BUSINESS_TYPE.get(+v)
  },
  id: {
    label: '发票申请编号',
    prop: 'invoiceOrderNo',
    width: '220px'
  },
  orderNo: {
    label: '订单编号',
    prop: 'orderNo',
    render(h, ctx, row) {
      const $vm = ctx.parent;
      const handler = row => {
        $vm.$router.push({
          path: '/orderMgmt/list',
          query: {
            orderNo: row.orderNo,
            part: 1,
            payType: row.payType
          }
        });

        // if (row.invoiceOrderType == 1) {
        //   $vm.$router.push({
        //     path: '/orderMgmt/list',
        //     query: {
        //       orderNo: row.orderNo,
        //       part: 1
        //     }
        //   });
        // } else {
        //   $vm.$router.push({
        //     name: 'zonghe',
        //     query: {
        //       orderNo: row.orderNo
        //     }
        //   });
        // }
      };
      return (
        <el-button type="text" onClick={handler.bind(this, row)}>
          {row.orderNo}
        </el-button>
      );
    }
  },
  companyName: {
    label: '供应商',
    prop: 'companyName'
  },
  paymentObject: {
    label: '支付对象',
    prop: 'companyName'
  },
  invoiceOrderType: {
    label: '订单类型',
    prop: 'invoiceOrderType',
    formatter(row) {
      return ORDER_TYPE.get(+row.invoiceOrderType);
    }
  },
  projectName: {
    label: '项目名称',
    prop: 'projectName'
  },
  taskDt: {
    label: '详情',
    prop: 'taskDt',
    formatter(row) {
      return '任务月度：' + row.taskDt;
    }
  },
  projectPrice: {
    label: '订单金额',
    prop: 'projectPrice',
    formatter(row) {
      return Vue.filter('moneyFixed')(row.projectPrice);
    }
  },
  receiveDt: {
    label: '收款时间',
    prop: 'receiveDt',
    formatter(row, ctx, v) {
      return Vue.filter('transAllTime')(v);
    }
  },
  createDt: {
    label: '申请时间',
    prop: 'createDt',
    formatter(row, ctx, v) {
      return Vue.filter('transAllTime')(v);
    }
  },
  openDt: {
    label: '通过时间',
    prop: 'openDt',
    formatter(row, ctx, v) {
      return Vue.filter('transAllTime')(v);
    }
  },
  authDt: {
    label: '驳回时间',
    prop: 'authDt',
    formatter(row, ctx, v) {
      return Vue.filter('transAllTime')(v);
    }
  },
  itemName: {
    label: '开票类目',
    prop: 'itemName'
  },
  enterpriseName: {
    label: '销售方',
    prop: 'enterpriseName'
  },
  invoiceCategory: {
    width: 120,
    label: '发票类目',
    prop: 'itemName'
  },
  invoiceStatus: {
    label: '开票状态',
    prop: 'invoiceStatus',
    render(h, ctx, row) {
      const vm = ctx.parent;
      const { invoiceStatus, noPassReason } = row;
      // 如果是 驳回
      const isDeney = +invoiceStatus === 3;
      if (isDeney) {
        return h(
          'el-button',
          {
            props: {
              disabled: !isDeney,
              type: 'text'
            },
            on: {
              click: () => {
                vm.$msgbox({
                  title: '驳回原因',
                  message: noPassReason
                });
              }
            }
          },
          STATUS_INVOICE.get(invoiceStatus)
        );
      }
      return h('span', STATUS_INVOICE.get(invoiceStatus));
    }
  },
  invoiceAmount: {
    label: '价税合计',
    prop: 'invoiceAmount',
    render(h, ctx, row) {
      const $vm = ctx.parent;
      const showDialog = () => {
        $vm.$xrkDialog({
          title: '价税合计',
          width: '80%',
          showConfirm: false,
          cancelText: '确认',
          cancelType: 'primary',
          $slots: {
            default: h(moneyList, {
              props: { options: row }
            })
          }
        });
      };

      return (
        <el-button type="text" onClick={showDialog}>
          {Vue.filter('moneyFixed')(row.invoiceAmount)}
        </el-button>
      );
    }
  },
  invoiceDetail: {
    label: '操作',
    prop: 'invoiceDetail',
    width: '180px',
    fixed: 'right',
    render(h, ctx, row) {
      const $vm = ctx.parent;

      const { invoiceBusinessType } = row;

      // 数据项 添加 xLock 值为 true 显示 loading 且 不能执行其他操作
      defineReactive(row, 'loading', false);

      // 待审核状态（供应商已上传发票） 可以执行 通过或者不通过
      // const canReview = +invoiceStatus === 1;

      // 展示详情：待审 && 已开
      // const hasDetail = +invoiceStatus !== 0;

      // 委托代开的没有"通过和不通过"   发票业务类型  1 汇总申报 2 委托代开(线上)发票
      const isCommission = +invoiceBusinessType === 2;
      const isPark = +invoiceBusinessType === 3;
      return h('div', [
        h(
          'el-button',
          {
            props: {
              type: 'text'
              // disabled: !hasDetail
            },
            on: {
              click: () => {
                // 如果是 委托代开
                if (isCommission) {
                  createExtend(detailOfCommission, {
                    row
                  });
                  return;
                }
                if (isPark) {
                  createExtend(detailOfPark, {
                    title: '发票详情列表（园区）',
                    row
                  });
                  return;
                }
                // OLD：非委托代开
                $vm.$parent.options.data = row;
                $vm.$xrkDialog({
                  title: '发票详情',
                  width: '80%',
                  showConfirm: false,
                  showCancel: false,
                  // cancelText: '确认',
                  // cancelType: 'primary',
                  $slots: {
                    default: h(invoiceDetail, {
                      props: {
                        itemData: {
                          data: row
                        },
                        isAudit: row.invoiceStatus === 1,
                        saveSuccess: function() {
                          $vm.handleSearch();
                        }
                      }
                    })
                  }
                });
              }
            }
          },
          '发票详情'
        ),
        +invoiceBusinessType === 3 && // 3园区个体
          h(
            'el-button',
            {
              props: {
                type: 'text',
                disabled: +row.invoiceStatus !== 2
              },
              on: {
                click: () => {
                  ctx.parent
                    .$downloadFile(
                      `/rest/cso/saas/invoice/downloadThePaper?invoiceCsoSupplierId=${row.id}`,
                      true
                    )
                    .then(res => {
                      const { status } = res;
                      if (+status === 1) {
                        ctx.parent
                          .$confirm(
                            '文件已经在下载中心内进行生成,如需下载请前往下载中心',
                            '通知',
                            {
                              showCancelButton: true,
                              cancelButtonText: '前往下载中心',
                              showConfirmButton: true,
                              confirmButtonText: '知道了'
                            }
                          )
                          .then(() => {})
                          .catch(() => {
                            ctx.parent.$router.push({ name: 'download' });
                          });
                      }
                    });
                }
              }
            },
            '下载'
          )
      ]);
    }
  },
  operation: {
    label: '操作',
    width: '80px',
    render: function(h, ctx, r) {
      const vm = ctx.parent;
      return (
        <div>
          <el-button
            onClick={vm.$exportFile.bind(this, r.bankPayVoucherUrl)}
            type="text"
          >
            下载回单
          </el-button>
        </div>
      );
    }
  },
  dakuanjine: {
    label: '打款金额',
    prop: 'projectPrice',
    formatter: null,
    render: (h, ctx, r) => {
      const vm = ctx.parent;
      const showDialog = () => {
        // stateType 1.支付对象,2 综合服务费，3委托代开自然人 4园区个体
        const { csoCustomOrderId, invoiceOrderType, stateType, id } = r;
        // 支付订单
        if (+invoiceOrderType === 1) {
          vm.$xrkDialog({
            title: '打款金额',
            width: '80%',
            showConfirm: false,
            cancelText: '确认',
            cancelType: 'primary',
            $slots: {
              default: h('div', [
                h(projectPriceTable, {
                  props: {
                    query: {
                      ...r,
                      csoCustomOrderId,
                      stateType,
                      csoCustomOrderSupplierId: id
                    }
                  }
                })
              ])
            }
          });
        }
        if (+invoiceOrderType === 2) {
          // const detail = createExtend(zongheDetail, {
          //   showDialog: true,
          //   mode: 'table',
          //   csoId: csoCustomOrderId
          // });
        }
      };

      return h(rowLink, {
        props: {
          text: moneyFixed(r.projectPrice)
        },
        on: {
          click: showDialog
        }
      });
    }
  },
  applicationStatus: {
    label: '申请进度',
    prop: 'applicationStatus'
  },
  ...bankRowLabelFiled
};
